"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagName = exports.OutlookClientId = exports.OfficeClientId = exports.TeamsClientId = exports.VSCodeExtensionCommand = exports.HelpLinks = exports.ConstantString = void 0;
class ConstantString {
}
exports.ConstantString = ConstantString;
ConstantString.UTF8Encoding = "utf-8";
ConstantString.DeploymentResourceType = "Microsoft.Resources/deployments";
ConstantString.DeploymentNotFound = "DeploymentNotFound";
ConstantString.RootFolder = "TeamsApps";
class HelpLinks {
}
exports.HelpLinks = HelpLinks;
HelpLinks.WhyNeedProvision = "https://aka.ms/teamsfx/whyneedprovision";
HelpLinks.ArmHelpLink = "https://aka.ms/teamsfx-arm-help";
HelpLinks.SwitchAccountOrSub = "https://aka.ms/teamsfx-switch-account-or-subscription-help";
HelpLinks.SwitchTenant = "https://aka.ms/teamsfx-switch-tenant";
class VSCodeExtensionCommand {
}
exports.VSCodeExtensionCommand = VSCodeExtensionCommand;
VSCodeExtensionCommand.showOutputChannel = "command:fx-extension.showOutputChannel";
VSCodeExtensionCommand.openFolder = "command:fx-extension.openFolder";
VSCodeExtensionCommand.openReadme = "command:fx-extension.openReadMe?%5B%22Notification%22%5D";
class TeamsClientId {
}
exports.TeamsClientId = TeamsClientId;
TeamsClientId.MobileDesktop = "1fec8e78-bce4-4aaf-ab1b-5451cc387264";
TeamsClientId.Web = "5e3ce6c0-2b1f-4285-8d4b-75ee78787346";
class OfficeClientId {
}
exports.OfficeClientId = OfficeClientId;
OfficeClientId.Desktop = "0ec893e0-5785-4de6-99da-4ed124e5296c";
OfficeClientId.Web1 = "4345a7b9-9a63-4910-a426-35363201d503";
OfficeClientId.Web2 = "4765445b-32c6-49b0-83e6-1d93765276ca";
class OutlookClientId {
}
exports.OutlookClientId = OutlookClientId;
OutlookClientId.Desktop = "d3590ed6-52b3-4102-aeff-aad2292ab01c";
OutlookClientId.Web1 = "00000002-0000-0ff1-ce00-000000000000";
OutlookClientId.Web2 = "bc59ab01-8403-45c6-8796-ac3ef710b3e3";
class FeatureFlagName {
}
exports.FeatureFlagName = FeatureFlagName;
FeatureFlagName.BicepEnvCheckerEnable = "TEAMSFX_BICEP_ENV_CHECKER_ENABLE";
// This will default to true and this environment is only for tests. It does not expose to user.
FeatureFlagName.InsiderPreview = "__TEAMSFX_INSIDER_PREVIEW";
FeatureFlagName.VSCallingCLI = "VS_CALLING_CLI";
FeatureFlagName.ExistingTabApp = "TEAMSFX_INIT_APP";
FeatureFlagName.AadManifest = "TEAMSFX_AAD_MANIFEST";
FeatureFlagName.DebugTemplate = "TEAMSFX_DEBUG_TEMPLATE";
FeatureFlagName.BotNotification = "BOT_NOTIFICATION_ENABLED";
FeatureFlagName.M365App = "TEAMSFX_M365_APP";
FeatureFlagName.ApiConnect = "TEAMSFX_API_CONNECT_ENABLE";
FeatureFlagName.DeployManifest = "TEAMSFX_DEPLOY_MANIFEST";
FeatureFlagName.Preview = "TEAMSFX_PREVIEW";
FeatureFlagName.CLIDotNet = "TEAMSFX_CLI_DOTNET";
FeatureFlagName.V3 = "TEAMSFX_V3";
FeatureFlagName.V3Migration = "TEAMSFX_V3_MIGRATION";
FeatureFlagName.VideoFilter = "TEAMSFX_VIDEO_FILTER";
FeatureFlagName.OfficeAddin = "TEAMSFX_OFFICE_ADDIN";
FeatureFlagName.CopilotPlugin = "DEVELOP_COPILOT_PLUGIN";
FeatureFlagName.ApiCopilotPlugin = "API_COPILOT_PLUGIN";
FeatureFlagName.SampleConfigBranch = "TEAMSFX_SAMPLE_CONFIG_BRANCH";
FeatureFlagName.TestTool = "TEAMSFX_TEST_TOOL";
FeatureFlagName.ApiKey = "API_COPILOT_API_KEY";
//# sourceMappingURL=constants.js.map